export default "__VITE_ASSET__BC53ys4m__"